import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Calculator } from "lucide-react";

const ROICalculator = () => {
  const [missedCalls, setMissedCalls] = useState<number>(10);
  const [customerValue, setCustomerValue] = useState<number>(500);

  const monthlyLoss = missedCalls * customerValue * 4;
  const virtualEmployeeCost = 299;
  const monthlySavings = monthlyLoss - virtualEmployeeCost;
  const paybackDays = Math.ceil((virtualEmployeeCost / monthlyLoss) * 30);

  return (
    <Card className="max-w-2xl mx-auto border-primary/30">
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Calculator className="h-6 w-6 text-primary" />
          </div>
          <CardTitle>Calculate Your Savings</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="missed-calls">Missed Calls Per Week</Label>
            <Input
              id="missed-calls"
              type="number"
              min="0"
              value={missedCalls}
              onChange={(e) => setMissedCalls(Number(e.target.value))}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="customer-value">Average Customer Value ($)</Label>
            <Input
              id="customer-value"
              type="number"
              min="0"
              value={customerValue}
              onChange={(e) => setCustomerValue(Number(e.target.value))}
            />
          </div>
        </div>

        <div className="bg-primary/5 p-6 rounded-lg space-y-4">
          <div className="grid md:grid-cols-3 gap-4 text-center">
            <div>
              <p className="text-sm text-muted-foreground mb-1">Monthly Loss</p>
              <p className="text-2xl font-bold text-destructive">
                ${monthlyLoss.toLocaleString()}
              </p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-1">Monthly Savings</p>
              <p className="text-2xl font-bold text-green-500">
                ${monthlySavings.toLocaleString()}
              </p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-1">Payback Period</p>
              <p className="text-2xl font-bold text-primary">
                {paybackDays} {paybackDays === 1 ? 'day' : 'days'}
              </p>
            </div>
          </div>
          <p className="text-center text-sm text-muted-foreground">
            A Virtual Employee pays for itself in less than {paybackDays} days
          </p>
        </div>

        <Button className="w-full" size="lg" asChild>
          <a href="#consultation">Schedule a Discovery Call</a>
        </Button>
      </CardContent>
    </Card>
  );
};

export default ROICalculator;
